import { Navigate } from 'react-router-dom';

import { useAuth, useSubscription } from '@chainlit/react-client';

type Props = {
  children: JSX.Element;
};

// Hard paywall: any authenticated non-admin user without an active subscription
// is redirected to /subscribe and cannot reach any other route.
const RequireSubscription = ({ children }: Props) => {
  const { data: config, isReady, isAuthenticated, user } = useAuth();
  const { hasActiveSubscription, isLoading, subscription } = useSubscription();

  if (!config?.requireLogin || !isReady || !isAuthenticated) {
    // Login isn't required app-wide, or auth state hasn't resolved yet — unrelated
    // to this change, not gating here.
    return children;
  }

  if (isLoading && !subscription) {
    return null;
  }

  const role = user?.metadata?.role;
  if (role !== 'ADMIN' && !hasActiveSubscription) {
    return <Navigate to="/subscribe" replace />;
  }

  return children;
};

export default RequireSubscription;
